// extracted by mini-css-extract-plugin
module.exports = {"container":"taskInformation_container__2a4gD","fadeImage":"taskInformation_fadeImage__2ZSod"};